export default __webpack_public_path__ + "static/media/news3.5b6b8c1b.webp";